export { default } from "./ShopPromotedStrainsCarousel";
